import { useMemo } from "react";
import { useIntl } from "react-intl";
import commonMessages from "../../../common/messages";
import messages from "./messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const result = useMemo(() => {
    const translations = {
      defaultError: formatMessage(commonMessages.defaultError),
      left: formatMessage(messages.sideLeft),
      right: formatMessage(messages.sideRight),
      patientDetailsIsNotAvailable: formatMessage(
        messages.patientDetailsIsNotAvailable,
      ),
      errorAppointmentUndefined: formatMessage(
        messages.errorAppointmentUndefined,
      ),
      errorPatientDetailsUndefined: formatMessage(
        messages.errorPatientDetailsUndefined,
      ),
      errorTimeSlotIsAlreadyTaken: formatMessage(
        messages.errorTimeSlotIsAlreadyTaken,
      ),
    };

    const addDialogTranslations = {
      addTitle: formatMessage(messages.addTitle),
      addDescription: formatMessage(messages.addDescription),
    };

    const editDialogTranslations = {
      editTitle: formatMessage(messages.editTitle),
    };

    return { translations, addDialogTranslations, editDialogTranslations };
  }, [formatMessage]);

  return result;
};
export default useTranslations;
